/* eslint-disable no-use-before-define */
'use strict';

var base = require('base/search/search');
var searchRefinements = require('./searchRefinements');
var storeSelectorModal = require('../product/modal/storeSelectorModal');
const mobileMq = window.matchMedia("(max-width: 767px)");

var searchExports = {};

Object.keys(base).forEach(key => {
    searchExports[key] = base[key];
});

$("#storeSelectorModal").on("shown.bs.modal", function () {
    $(this).siblings().attr("aria-hidden", "true");
    $(".checkout-btn").trigger("focus");
});

$("#storeSelectorModal").on("hidden.bs.modal", function () {
    $(this).siblings().attr("aria-hidden", "false");
});

$("#storeSelectorModal").on("keydown", function (e) {

    if (e.key !== "Tab") {
        return;
    }

    const focusable = $(this)
        .find(
            "button,a,input,select,textarea,[tabindex]:not([tabindex='-1'])"
        )
        .filter(":visible");

    const first = focusable.first()[0];
    const last = focusable.last()[0];

    if (e.shiftKey) {

        if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
        }

    } else {

        if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }

    }

});

// Agregar en search.js, junto al resto de los handlers delegados.
// Enter ya funciona nativo en un <a href> — esto cubre solo Space, que
// los links nunca manejan por default (a diferencia de <button>).

$(document).on("keydown", ".refinement-pill-a", function (e) {
    if (e.key === " " || e.key === "Spacebar" || e.keyCode === 32) {
        e.preventDefault(); // evita el scroll de página que Space dispara por default
        $(this).trigger("click");
    }
});

$(document).on(
    "shown.bs.collapse",
    '.card-body[data-js-attribute="storeInventoryIds"]',
    function () {
        var canonicalEvents = require("../analytics/canonicalEvents");
 
        var deliveryMethod = $('[name="checkoutDeliveryMethod"]').val() || null;
        var storeId = $('[name="selectedStoreId"]').val() || null;
 
        var selectedStore = storeId
            ? canonicalEvents.toStorePayload({
                  ID: storeId,
                  name: $('[name="selectedStoreName"]').val() || null,
                  city: $('[name="selectedStoreCity"]').val() || null,
                  province: $('[name="selectedStoreState"]').val() || null,
              })
            : null;
 
        var hasStoreSelected = !!selectedStore;
 
        canonicalEvents.pushCanonicalEvent("store_picker_opened", {
            surface: "plp",
            source: "plp_store_filter",
            selected_store: selectedStore,
            delivery_method: deliveryMethod,
            entry_state: hasStoreSelected ? "has_store_selected" : "no_store_selected",
        });
    },
);

/**
 * Closes the store selector message when the close button is clicked.
* */
$(document).on("click", ".store-selector-message__close", function () {
    $(this)
        .closest(".store-selector-message")
        .stop(true, true)
        .fadeOut(200, function () {
            $(this).addClass("d-none").show();
        });
});

/**
 * Hides the store selector message with a fade-out animation.
 */
function hideStoreSelectorMessage() {
    $(".store-selector-message")
        .stop(true, true)
        .fadeOut(200, function () {
            $(this).addClass("d-none").show();
        });
}

/**
 * Displays the store selector message with a fade-in animation.
 */
function showStoreSelectorMessage() {
    var message = $(".store-selector-message");

    message
        .stop(true, true)
        .removeClass("d-none")
        .hide()
        .fadeIn(200);
}

function mappingValuesPrice(min, max, target) {
    const minValue = (min && typeof min === "string") ? min.replace(/\D/g, "") : "";
    const maxValue = (max && typeof max === "string") ? max.replace(/\D/g, "") : "";
    const numMin = parseInt(minValue);
    const numMax = parseInt(maxValue);

    const minPriceCategory = parseInt($("input[name$=minPriceCategory]").val());
    const maxPriceCategory = parseInt($("input[name$=maxPriceCategory]").val());

    const btn = $(".btn-price-range");

    // Verificar si los valores son números válidos y si cumplen con las condiciones
    // Deshabilita Boton de search, muestra msg
    const numMinFilled = !isNaN(numMin);
    const numMaxFilled = !isNaN(numMax);

    if (
        numMinFilled &&
        numMaxFilled &&
        maxPriceCategory >= numMin &&
        minPriceCategory <= numMax &&
        numMax > numMin
    ) {
        $(".no-results-price-msg").addClass("d-none");
        btn.prop("disabled", false);
    } else {
        if (numMinFilled && numMaxFilled) {
            $(".no-results-price-msg").removeClass("d-none");
        } else {
            $(".no-results-price-msg").addClass("d-none");
        }
        btn.prop("disabled", true);
    }

    // Mapping URL button to search
    var urlBase = $("[data-url-prices]").text();
    // Usa URL y URLSearchParams para manipular solo los parámetros deseados
    if (urlBase) {
    var url = new URL(urlBase, window.location.origin);
    var params = url.searchParams;
    // Reemplaza o agrega pmin y pmax sin borrar nada más
    params.set("pmin", minValue);
    params.set("pmax", maxValue);

    // Reconstruye la URL completa
    var priceUrl = url.pathname + "?" + params.toString();

    var buttonSearchPrices = $("[data-search-prices]");
    buttonSearchPrices.attr("data-href", priceUrl);
    buttonSearchPrices.attr("data-min-price", minValue);
    buttonSearchPrices.attr("data-max-price", maxValue);
    }

    let formatValueMin = minValue ? "$" + minValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "";
    let formatValueMax = maxValue ? "$" + maxValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "";

    // Reinicia el valor de los inputs
    if (target && (target.hasClass("reset") || target.hasClass("button-price-range"))) {
        formatValueMin = "";
        formatValueMax = "";
        $("[data-search-prices]").removeAttr("data-href data-min-price data-max-price");
        $(".btn-price-range").prop("disabled", true);
        $(".no-results-price-msg").addClass("d-none");
    }

    if (formatValueMin === "" && formatValueMax === "") {
        $(".no-results-price-msg").addClass("d-none");
    }

    $("[data-min-input-price]").val(formatValueMin);
    $("[data-max-input-price]").val(formatValueMax);
}

function functionchangePrice() {
    $(document).on("input keydown", ".form_control_section", function (e) {
        var min = $("[data-min-input-price]").val();
        var max = $("[data-max-input-price]").val();
        mappingValuesPrice(min, max, false);
    });

    // Evitar copy/paste
    $(".form_control_section").on("copy paste cut", function (e) {
        e.preventDefault();
    });

    $('.pills-container').each(function() {
        $(this).find('.prices-pill').not(':first').remove();
    });
}

/**
 * Empties the current basket and reapplies the pending store filter, if any.
 */
$(document).on("click", ".js-store-empty-cart", function () {

    var url = $(this).data("url");

    $.spinner().start();

    $.ajax({
        url: url,
        type: "POST",
        success: function (response) {

            $.spinner().stop();

            if (!response.success) {
                return;
            }

            var canonicalEvents = require("../analytics/canonicalEvents");
            var previousStoreId = $('[name="selectedStoreId"]').val() || null;
 
            canonicalEvents.pushCanonicalEvent("store_cleared", {
                surface: "plp",
                source: "change_store_confirmation",
                selected_store: null,
                delivery_method: null,
                previous_selected_store: previousStoreId
                        ? canonicalEvents.toStorePayload({
                              ID: previousStoreId,
                              name:
                                  $('[name="selectedStoreName"]').val() || null,
                              city:
                                  $('[name="selectedStoreCity"]').val() || null,
                          })
                        : null,
                cart_had_items: true,
            });
 
            canonicalEvents.updateGlobalDeliveryState(null, null);
 
            $("#storeSelectorModal").modal("hide");
            storeSelectorModal.focusAfterEmptyCart();
            $('.minicart').trigger('count:update', response);
            $(".minicart-quantity").empty().addClass("d-none");

            if (window.pendingStoreFilter) {

                executeFilter(
                    window.pendingStoreFilter.target,
                    window.pendingStoreFilter.event,
                    window.pendingStoreFilter.url
                );

                window.pendingStoreFilter = null;
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
});

/**
 * Muestra un error genérico en el contexto de los filtros, con la acción
 * "Reintentar". Se inserta arriba de la lista de filtros (.refinements): cuando
 * un pedido posterior sale bien, parseResults reemplaza ese contenedor y el
 * error desaparece solo.
 * @param {Function} onRetry
 * @returns {void}
 */
function showFilterError(onRetry) {
    $("[data-js-filter-error-retry]").remove();

    var $box = $(
        '<div class="filter-retry-error alert alert-danger" role="alert" data-js-filter-error-retry></div>',
    );

    $box.append($("<p></p>").text("No pudimos actualizar los resultados."));

    var $host = $(".refinements").first();

    if (!$host.length) {
        $host = $(".search-results").first();
    }

    $host.prepend($box);
}

/**
 * Evento provisional store_picker_error. Se emite cuando se muestra el
 * estado de error del listado de sucursales, y solo ahí: nunca por
 * carga, búsqueda sin coincidencias ni listado vacío sin falla técnica.
 * surface y filter_name son valores fijos del criterio de aceptación; brand (el
 * del sitio) y schema_version los pone pushCanonicalEvent. error_code es
 * provisional: el status HTTP, o un código genérico si no hubo respuesta.
 * El naming final y el mapping GA4/GTM se validan en us-T1.
 * @param {Object} jqXHR
 * @param {string} textStatus
 * @returns {void}
 */
function pushStorePickerError(jqXHR, textStatus) {
    var canonicalEvents = require("../analytics/canonicalEvents");
    var errorCode = jqXHR && jqXHR.status
        ? String(jqXHR.status)
        : (textStatus === "error" ? "network_error" : textStatus || "unknown");

    canonicalEvents.pushCanonicalEvent("store_picker_error", {
        surface: "plp_filter",
        error_code: errorCode,
        filter_name: "retiro_por_sucursal",
    });
}

/**
 * Applies the selected filter, updates the URL, refreshes the search results,
 * and handles the store selector state.
 */
function executeFilter(target, e, url, hasItems) {
    const searchBackUrl = JSON.parse($("#searchBackUrl").val());

    // Con la feature (enableStoreSelector) apagada, el comportamiento queda como
    // estaba (legacy): sin estado de error nuevo, sin evento, y la URL como antes.
    var storeSelectorOn = $('input[name="enableStoreSelector"]').val() === "true";

    var requestedUrl = url;

    // Restore the friendly URL when navigating back from search.
    // Feature activa: se actualiza recién en el success, cuando el listado ya se
    // actualizó (si el pedido falla, la URL no cambia). Feature apagada: como
    // antes, antes del pedido.
    if (searchBackUrl && !storeSelectorOn) {
        updateUrlToFrendly(location.origin + url);
    }

    // ------------------------------------------------------------------
    // Store Selector - Add or update the selected store refinement in the URL.
    // ------------------------------------------------------------------
    if (
        target.hasClass("store-filter") ||
        target.hasClass("store-refinement")
    ) {
        const storeId = target.data("store-id");
        const urlObj = new URL(url, window.location.href);
        const params = urlObj.searchParams;

        let existingIndex = null;

        params.forEach(function (value, key) {
            if (
                value === "storeInventoryIds" &&
                key.startsWith("prefn")
            ) {
                existingIndex = key.replace("prefn", "");
            }
        });

        if (existingIndex) {
            params.set("prefv" + existingIndex, storeId);
        } else {
            const nextIndex = params.getAll("prefn").length + 1;
            params.set("prefn" + nextIndex, "storeInventoryIds");
            params.set("prefv" + nextIndex, storeId);
        }

        url = urlObj.pathname + "?" + params.toString();
    }

    // Remove the store refinement when the Store Selector feature is disabled.
    const enableStoreSelector = $('input[name="enableStoreSelector"]').val() === "true";

    if (!enableStoreSelector) {
        url = removeStoreInventoryIds(url);
    }

    const sruleValue = $("#product-search-results").attr("data-srule");
    const urlObj = new URL(url, window.location.href);

    urlObj.searchParams.set("srule", sruleValue);
    url = urlObj.toString();

    // Remove the store refinement when clearing filters.
    if (target.hasClass("reset")) {
        url = target.data("href");

        if (!target.hasClass("reset_button_mobile")) {
            target.addClass("d-none");
            $(".filters-applied").addClass("d-none");
        }
    }

    if (
        target.hasClass("reset") ||
        target.hasClass("removeFilter")
    ) {
        url = removeStoreInventoryIds(target.data("href"));
        if (storeSelectorOn) {
            url += (url.indexOf("?") > -1 ? "&" : "?") + "clearStore=true";
        }
    }

    if (searchBackUrl && !storeSelectorOn) {
        updateUrlToFrendly(location.origin + url);
    }

    $.spinner().start();

    target.trigger("search:filter", e);

    var min = $("[data-min-input-price]").val();
    var max = $("[data-max-input-price]").val();

    $.ajax({
        url: url,
        data: {
            page: $(".grid-footer").data("page-number"),
            selectedUrl: url
        },
        method: "GET",
        success: function (response) {
            // Restore the friendly URL: ahora que el listado se actualizó.
            if (searchBackUrl && storeSelectorOn) {
                updateUrlToFrendly(location.origin + url);
            }

            parseResults(response);

            $(".pills-container").each(function () {
                $(this).find(".prices-pill").not(":first").remove();
            });

            $.spinner().stop();

            displayMessage();
            mappingValuesPrice(min, max, target);

            if (min && max) {
                searchRefinements.displayActualPriceFilter(min, max, target);
            }

            selectedCounter();
            searchFilterFuctionality();
            updateLayout(mobileMq);

            // Toggle the store selector message based on the applied filters.
            if ((target.hasClass("store-filter") || target.hasClass("store-refinement")) && hasItems) {
                showStoreSelectorMessage();
            }

            // store_selected — se confirma una sucursal desde PLP.
            if (target.hasClass("store-filter") || target.hasClass("store-refinement")) {
                var canonicalEvents = require("../analytics/canonicalEvents");
                var storeId = target.data("store-id");

                var previousStoreId =
                    $('[name="selectedStoreId"]').val() || null;

                var previousSelectedStore = previousStoreId
                    ? canonicalEvents.toStorePayload({
                          ID: previousStoreId,
                          name: $('[name="selectedStoreName"]').val() || null,
                          city: $('[name="selectedStoreCity"]').val() || null,
                          province: $('[name="selectedStoreState"]').val() || null,
                      })
                    : null;

                var newSelectedStore = storeId
                    ? canonicalEvents.toStorePayload({
                          ID: storeId,
                          name: target.data("store-name"),
                          city: target.data("store-city"),
                          province: target.data("store-state")
                      })
                    : null;

                canonicalEvents.pushCanonicalEvent("store_selected", {
                    surface: "plp",
                    source: "plp_store_filter",
                    selected_store: newSelectedStore,
                    delivery_method: "retiro-sucursal",
                    previous_selected_store: previousSelectedStore,
                });

                canonicalEvents.updateGlobalDeliveryState("retiro-sucursal", newSelectedStore);
            }

            if ((target.hasClass("removeFilter") && target.data("refinement-id") === "storeInventoryIds") || target.hasClass("reset")) {
                hideStoreSelectorMessage();

                var canonicalEventsForClear = require("../analytics/canonicalEvents"); // eslint-disable-line no-redeclare
                var previousStoreIdForClear = $('[name="selectedStoreId"]').val() || null;

                if (previousStoreIdForClear) {
                    var previousSelectedStoreForClear =
                        canonicalEventsForClear.toStorePayload({
                            ID: previousStoreIdForClear,
                            name: $('[name="selectedStoreName"]').val() || null,
                            city: $('[name="selectedStoreCity"]').val() || null,
                            province: $('[name="selectedStoreState"]').val() || null,
                        });

                    canonicalEventsForClear.pushCanonicalEvent(
                        "store_cleared",
                        {
                            surface: "plp",
                            source: "plp_store_filter",
                            selected_store: null,
                            delivery_method: null,
                            previous_selected_store:
                                previousSelectedStoreForClear,
                            cart_had_items: !!hasItems,
                        },
                    );
                }

                canonicalEventsForClear.updateGlobalDeliveryState(null, null);
            }
        },
        error: function (jqXHR, textStatus) {
            $.spinner().stop();

            // Pedido cancelado a propósito (ej. el usuario navegó): no es un error.
            if (textStatus === "abort") {
                return;
            }

            // Feature apagada: legacy, sin estado de error nuevo ni evento.
            if (!storeSelectorOn) {
                return;
            }

            // Se deshace lo que se ocultó antes de pedir (botón "reset" y "filtros aplicados").
            if (target.hasClass("reset") && !target.hasClass("reset_button_mobile")) {
                target.removeClass("d-none");
                $(".filters-applied").removeClass("d-none");
            }

            showFilterError(function () {
                executeFilter(target, e, requestedUrl, hasItems);
            });

            pushStorePickerError(jqXHR, textStatus);
        },
    });
}

$(document).ready(function () {

  // Search placeholder - lowercase except the first letter
  function capitalizeFirstOnly(text) {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  $('input.search-filter').each(function () {
    const $input = $(this);
    const placeholder = $input.attr('placeholder');
    if (placeholder) {
      $input.attr('placeholder', capitalizeFirstOnly(placeholder));
    }
  });

  // Search filter option
  searchFilterFuctionality();
});

// Update layout styles based on screen size
function updateLayout(mq) {
  $('.card-header').each(function () {
    const $header = $(this);
    const isMobileActive = $header.parent('.card').hasClass('active');
    const $refinement = $header.find('.refinement-pill-a');

    if (mq.matches) {
      $header.toggleClass('header-color', isMobileActive);
    } else {
      const isExpanded = $refinement.attr('aria-expanded') === 'true';
      $header.toggleClass('header-color', isExpanded);
    }
  });
}

$(window).on('resize', function () {
    updateLayout(mobileMq);
});

// Header list Click functionality
$(document).on('click', 'div.card-header', function () {
  const $header = $(this);
  const isMobileActive = $header.parent('.card').hasClass('active');
  const $refinement = $header.find('.refinement-pill-a');
  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  if (isMobile) {
    $header.toggleClass('header-color', isMobileActive);
  } else {
    const isExpanded = $refinement.attr('aria-expanded') === 'true';
    $header.toggleClass('header-color', isExpanded);
  }
});

$(document).ready(function () {
    $('.close__custom').on('click', function () {
        if ($('#fromInput').val() !== '0' || $('#toInput') !== '1000000') {
            $('[data-search-prices]').click();
        }
    });
    pushProductImpressionGtmEvent();
});

$('body').on('search:showMoreFinished', function () {
    pushProductImpressionGtmEvent();
});

$('.container').on('click', '.product .product-tile', function (event) {
    var currentScrollPosition = window.scrollY;
    sessionStorage.setItem('scrollPosition', currentScrollPosition);
    try {
        var productTile = $(event.target).closest(".product-tile");
        var productGtmDataValue = $(productTile).find(".productGtmData").val();
        var $categoryInfo = $('.category-information');
        var categoryId = $categoryInfo.data('category-id');
        var categoryName = $categoryInfo.data('category-name');

        var productClickGtmEvent = {
            event: "select_item",
            ecommerce: {
                item_list_id: categoryId,
                item_list_name: categoryName,
                items: JSON.parse(productGtmDataValue),
            },
        };
        if (typeof productClickGtmEvent === "object" && productClickGtmEvent !== null) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(productClickGtmEvent);
        }
    } catch (e) {
        // Nothing to do here
    }
});
/** NET-939 END **/

/**
 * DAB-4756 BEGIN - push datalayer Search event Google Tag manager
 */
// var searchGtmHiddenInput = $('#searchGtmEvent').val();
// var parsedSearchGtmValue = JSON.parse(searchGtmHiddenInput);
// window.dataLayer = window.dataLayer || [];
// window.dataLayer.push(parsedSearchGtmValue);
/**
 * DAB-4756 END
 */

$(document).on('click', '.refinement-pill-a', function () {
    let anyExpanded = false;

    $('.refinement-pill-a').each(function () {
        if ($(this).attr('aria-expanded') === 'true') {
            anyExpanded = true;
            return false;
        }
    });

    if (anyExpanded) {
        $('.refinements-container').addClass('refinements-track-scrollbar');
    } else {
        $('.refinements-container').removeClass('refinements-track-scrollbar');
    }
});

if ($('.swatch-circle-null')) {
    $('.swatch-circle-null').closest('.show-more-options-wrapper').hide();
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.result-count',
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.custom_cta_buttons'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

function createSearchShowUrlWithParams(showMoreUrlFromController) {
    var searchPattern = '/Search-UpdateGrid?';
    var showMoreUrl = showMoreUrlFromController;
    var modifiedUrlWithShowController = showMoreUrl.replace(searchPattern, '/Search-Show?');
    var url = new URL(modifiedUrlWithShowController);
    if (url.searchParams.has('sz') && url.searchParams.has('start')) {
        var startValue = Number(url.searchParams.get('start'));
        var szValue = Number(url.searchParams.get('sz'));
        var totalSize = startValue + szValue;
        var totalSizeToString = totalSize.toString();
        url.searchParams.set('sz', totalSizeToString);
        url.searchParams.set('start', '0');
        var updatedUrl = url.toString();
        return updatedUrl;
    }
    return modifiedUrlWithShowController;
}

function selectedCounter() {
  const pillsContainer = $(".pills-container");
  const $highlightFilters = $('.highlight-filters-container');
  const containerFiltro = $(".refinements-applied-container");
  const hasPills = pillsContainer.find(".refinement-pill").length > 0;
  const isMobile = mobileMq.matches;
  const $refinementsContainer = $('.filter-applied-plp-mobile .refinements-applied-container');

  // Ajusta las clases según si hay filtros aplicados y si es móvil o no
  pillsContainer.toggleClass("pills-marging", hasPills && !isMobile);
  containerFiltro.toggleClass("pills-marging-mobile", hasPills && isMobile);
  $refinementsContainer.addClass('d-none');

  // Activa o desactiva el botón, y muestra u oculta elementos según haya filtros
  $(".custom_cta_button_filter").prop("disabled", !hasPills);
  $(".quantity-filter, .filters-applied, #eraseFilters")
    .toggleClass("d-none", !hasPills);

    $highlightFilters.children('ul').length === 0 ? $highlightFilters.addClass('marging-auto') : " ";
}

function displayMessage() {
    const inputSelector = $('[data-js-invalid-filter]');
    let isInvalidFilter = false;

    if (inputSelector.length 
        && inputSelector.val() !== undefined 
        && inputSelector.val() !== null 
        && inputSelector.val() !== 'null' 
        && inputSelector.val() !== 'undefined' 
        && inputSelector.val().trim() !== ''
        && inputSelector.val()) {
        isInvalidFilter = inputSelector.val();
    }

    if (isInvalidFilter === 'true') {
        var errorMsg = $('<div>', {
            class: 'b-filter_error alert alert-danger',
            html: 'No hay productos cercanos a tu ubicación.<br>Sin embargo, te mostramos todos los productos disponibles para retiro ya.'
        })
        .attr('data-js-filter-error', '');
    
        $('body').append(errorMsg);
    
        setTimeout(() => {
            $('[data-js-filter-error]').remove();
        }, 12000);
    }
}

function updateUrlToFrendly(currentUrl) {
    var dataUrl = new URL(currentUrl);
    var isCategorySearch = $('#is-category-search').val() === 'true';
    var pathname;
    var newUrl;

    if (isCategorySearch) {
        pathname = $('#category-pathname').val();
    } else {
        pathname = $('#search-pathname').val();
    }

    newUrl = constructNewUrl(dataUrl, pathname);
    history.pushState(null, null, newUrl);
}

// return a string by newUrl//
function constructNewUrl(dataUrl, categoryPathname) {
    var filters;
    var newSearchParams;

    if (dataUrl.search.includes('prefv')) {
        filters = filterFrendly(decodeURI(dataUrl.search), categoryPathname);
        newSearchParams = getSearchParams(decodeURI(dataUrl.search));
        return getSearchParamsFilters(decodeURI(newSearchParams), decodeURI(filters));
    }
    newSearchParams = getSearchParams(decodeURI(dataUrl.search));
    if (newSearchParams) {
        return categoryPathname + '?' + newSearchParams.replace('?', '');
    }
    return categoryPathname;
}

function getSearchParamsFilters(newSearchParams, filters) {
    var result;
    if (newSearchParams) {
        if (new RegExp('^&').test(newSearchParams)) {
            result = replaceAccents(filters + newSearchParams.replace(new RegExp(/%252C/g), '%2C'));
        } else {
            result = replaceAccents(filters + newSearchParams.replace(new RegExp(/%252C/g), '%2C'));
        }
    } else {
        result = replaceAccents(filters);
    }
    return result;
}

function getSearchParams(dataUrlSearch) {
    return dataUrlSearch;
}

/** contruct newPathname = categoryPathname + filtersFrendly **/
function filterFrendly(dataUrl, categoryPathname) {
    return replaceAccents(categoryPathname);
}

/** replace Accents on string **/
function replaceAccents(stringToReplace) {
    var chars = {
        á: 'a',
        é: 'e',
        í: 'i',
        ó: 'o',
        ú: 'u',
        à: 'a',
        è: 'e',
        ì: 'i',
        ò: 'o',
        ù: 'u',
        ñ: 'n',
        Á: 'A',
        É: 'E',
        Í: 'I',
        Ó: 'O',
        Ú: 'U',
        À: 'A',
        È: 'E',
        Ì: 'I',
        Ò: 'O',
        Ù: 'U',
        Ñ: 'N'
    };
    var expr = /[áàéèíìóòúùñ]/ig;
    var res = stringToReplace.replace(expr, function (e) { return chars[e]; });
    return res;
}

/** NET-939 BEGIN **/
function pushProductImpressionGtmEvent() {
    try {
        var $productElements = $('.productGtmData[data-gtmpushed!="true"]');

        if (!$productElements.length) {
            return;
        }

        var $categoryInfo = $('.category-information');
        var categoryId = $categoryInfo.data('category-id');
        var categoryName = $categoryInfo.data('category-name');

        var gtmEvent = {
            event: "view_item_list",
            ecommerce: {
                item_list_id: categoryId || "",
                item_list_name: categoryName || "",
                items: [],
            },
        };

        var lastPositionPushed = 0;
        var gtmLastPositionPushedElementList = $(
            ".productGtmData[data-gtmlastpospushed]"
        );

        if (gtmLastPositionPushedElementList.length > 0) {
            var lastPositionPushedValue = $(
                gtmLastPositionPushedElementList[0]
            ).attr("data-gtmlastpospushed");
            lastPositionPushed = parseInt(lastPositionPushedValue, 10);
            $(gtmLastPositionPushedElementList[0]).removeAttr(
                "data-gtmlastpospushed"
            );
        }

        var productList = $(".category-id").val();
        $productElements.each(function (index, element) {
            var productGtmDataValue = $(element).val();
            var productGtmData = JSON.parse(productGtmDataValue);
            productGtmData[0].index = lastPositionPushed;
            lastPositionPushed++;

            for (var i = 0; i < productGtmData.length; i++) {
                gtmEvent.ecommerce.items.push(productGtmData[i]);
            }
            $(element).attr("data-gtmpushed", "true");
        });
        $($productElements[$productElements.length - 1]).attr(
            "data-gtmlastpospushed",
            lastPositionPushed
        );

        if (typeof gtmEvent === "object" && gtmEvent !== null) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(gtmEvent);
        }
    } catch (ex) {
        // Nothing to do here
    }
}

function normalizeText(text) {
    return (text || "")
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
}

/** AZ-19208 Search Option Functionality - Filters **/
function searchFilterFuctionality() {

    var storeSearchTrackingTimeout = null; // declarar arriba de searchFilterFuctionality(), no acá adentro

    $(document).on("input keydown", "input.search-filter", function (e) {
        if (e.type === "keydown" && (e.key === "Enter" || e.keyCode === 13)) {
            e.preventDefault();
            return;
        }

        if (e.type !== "input") return;

        const $input = $(this);
        const query = normalizeText($input.val());
        const $container = $input.closest(".search-refinement-container");
        const $list = $container.siblings("ul.values.content");
        const $items = $list.find("li");
        const $spans = $list.find(".show-more-options-wrapper");
        const $toggleButton = $container.siblings(".toggle-refinements-btn");
        const $filtersApplied = $list.find(".pills-container-singleFilter");
        const $moreResults = $toggleButton.find(".see-more-results");
        const $lessResults = $toggleButton.find(".see-less-results");
        const $spaceCardBody = $list.parent(".card-body.content");

        // Hide the ver más button and show all the spans to search for when searching
        $toggleButton.addClass("d-none");
        $moreResults.addClass("d-none");
        $spaceCardBody.removeClass("space-card-body");
        $spans.show();
        $list.addClass("expanded");

        // Determine the number of visible items by default (for color and size is 15);
        const attr = $list
            .parent(".card-body.content")
            .attr("data-js-attribute");
        const limit = attr === "size" || attr === "refinementColor" ? 12 : 5;

        // If the input field is empty, restore original behavior
        if (query === "" && $spans.length > limit) {
            $spans.slice(limit).hide();
            $list.removeClass("expanded");
            $toggleButton.removeClass("d-none");
            $filtersApplied.removeClass("d-none");
            $moreResults.removeClass("d-none");
            $lessResults.addClass("d-none");
            $spaceCardBody.addClass("space-card-body");
        }

        // filter list elements
        $items.each(function () {
            const $item = $(this);
            const $button = $item.find("button");
            let searchableText = $item.text();

            $.each($button.data(), function (key, value) {
                if (value) {
                    searchableText += " " + value;
                }
            });

            searchableText = normalizeText(searchableText);
            $item.toggle(query === "" || searchableText.includes(query));
        });

        // Show/hide no results msg
        let $msg = $container.find(".no-results-filter-msg");
        const anyVisible = $items.is(":visible");
        const showMsg = !anyVisible && query !== "";
        $msg.toggle(showMsg);
        $filtersApplied.toggle(!showMsg);

        if (attr === "storeInventoryIds") {
            const $statusRegion = $container.find("[data-js-store-search-status]");
            const visibleCount = $items.filter(":visible").length;

            const statusMessage =
                visibleCount > 0
                    ? visibleCount + " sucursales encontradas"
                    : "No se encontraron sucursales";

            $statusRegion.text(statusMessage);
        }

        // ================================================================
        // store_searched. "attr" ya estaba
        // calculado arriba (data-js-attribute del card-body) — se reusa, no
        // se vuelve a consultar el DOM. Debounce propio de 300ms, separado
        // del filtrado en vivo de arriba (que sigue siendo instantáneo).
        // ================================================================
        if (attr === "storeInventoryIds") {
            clearTimeout(storeSearchTrackingTimeout);

            var rawSearchTerm = $input.val();

            storeSearchTrackingTimeout = setTimeout(function () {
                var canonicalEvents = require("../analytics/canonicalEvents");
                var resultsCount = $items.filter(":visible").length;

                var deliveryMethod =
                    $('[name="checkoutDeliveryMethod"]').val() || null;
                var storeId = $('[name="selectedStoreId"]').val() || null;

                var selectedStore = storeId
                    ? canonicalEvents.toStorePayload({
                          ID: storeId,
                          name: $('[name="selectedStoreName"]').val() || null,
                          city: $('[name="selectedStoreCity"]').val() || null,
                          province: $('[name="selectedStoreState"]').val() || null,
                      })
                    : null;

                canonicalEvents.pushCanonicalEvent("store_searched", {
                    surface: "plp",
                    source: "store_picker_search",
                    selected_store: selectedStore,
                    delivery_method: deliveryMethod,
                    search_term: rawSearchTerm,
                    results_count: resultsCount,
                });
            }, 300);
        }
    });

    // Set initial visibility for list
    $(".values.content").each(function () {
        const $list = $(this);
        const $spaceCardBody = $list
            .parent(".card-body.content");
        const attr = $spaceCardBody.attr("data-js-attribute");
        const $spans = $list.find(".show-more-options-wrapper");
        const $toggleButton = $list.siblings(".toggle-refinements-btn");
        const limit = attr === "size" || attr === "refinementColor" ? 12 : 5;
        const $container = $toggleButton.find(".see-more-results");

        if ($spans.length > limit) {
            $spans.slice(limit).hide();
            $toggleButton.removeClass("d-none");
            $container.removeClass("d-none");
            $spaceCardBody.addClass('space-card-body');
        } else {
            $toggleButton.addClass("d-none");
            $container.addClass("d-none");
            $spaceCardBody.removeClass('space-card-body');
        }
    });

    // Ver más / Ver menos Button to expand/collapse options
    $(".toggle-refinements-btn").on("click", function () {
        const $button = $(this);
        const $list = $button.siblings(".values.content");
        const attr = $list
            .parent(".card-body.content")
            .attr("data-js-attribute");
        const $spans = $list.find(".show-more-options-wrapper");
        const limit = attr === "size" || attr === "refinementColor" ? 12 : 5;
        const $moreResults = $button.find(".see-more-results");
        const $lessResults = $button.find(".see-less-results");

        const isExpanded = $list.hasClass("expanded");
        if (isExpanded) {
            $spans.slice(limit).hide();
            $list.removeClass("expanded");
            $lessResults.addClass("d-none");
            $moreResults.removeClass("d-none");
        } else {
            $spans.slice(limit).show();
            $list.addClass("expanded");
            $lessResults.removeClass("d-none");
            $moreResults.addClass("d-none");
        }
    });
}

/** Remove storeInventoryIds refinement attribute in specific case
 * @nameremoveStoreInventoryIds
 * @param {String} url
 * @returns {String}
 */
function removeStoreInventoryIds(url) {
    let availableForPickupRegex = /prefn\d+=availableForInStorePickup/;
    let storeInventoryIdsRegex = /prefn\d+=storeInventoryIds/;

    let hasAvailableForPickup = availableForPickupRegex.test(url);
    let hasStoreInventoryIds = storeInventoryIdsRegex.test(url);

    if (hasStoreInventoryIds && !hasAvailableForPickup) {
        url = url.replace(/&?prefn\d+=storeInventoryIds&?prefv\d+=[^&]*/, '');
        url = url.replace(/\?&/, '?'); // Corrige si queda "?&"
        url = url.replace(/&$/, ''); // Corrige si queda "&" al final
    }

    return url;
}

searchExports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $(document).on('click', 'button.filter-results', function () {
            $('.refinement-bar').removeAttr('style');
            $('.refinement-bar').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
            $('body').addClass('no-scroll');
            const isMobile = mobileMq.matches;
            let offset = isMobile ? $('header').height() - 3 : 0;

            const $featured = $('.container-fluid.featured');
            if ($featured.length && $featured.height() > 0) {
            offset -= $featured.height();
            }

            $('.refinement-bar-container').css('top', offset);
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $(document).on('click', '.refinement-bar button.close', function () {
            $('.refinement-bar').removeAttr('style');
            $('#maincontent').removeClass('fixed');
            $('.refinement-bar').hide();
            $('.carousel-fade').removeClass('d-none');
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
            $('body').removeClass('no-scroll');
        });
    },

    init: function () {
        $('body').on('click', '.show-more-options', function (event) {
            var $target = $(event.target);
            var optionsToShow = $target.siblings('.show-more-options-wrapper').not('.show-more-options-wrapper.active');
            var remainingElementsCount = optionsToShow.length;
            var loopEnd = remainingElementsCount > 5 ? 5 : remainingElementsCount;
            for (var i = 0; i < loopEnd; i++) {
                $(optionsToShow[i]).show();
                $(optionsToShow[i]).addClass('active');
            }
            if (remainingElementsCount > 5) {
                $target.parent().append($target.clone());
            }
            $target.remove();
        });

        let url = window.location.href;
        const enableStoreSelector = $('input[name="enableStoreSelector"]').val() === "true";

        if (!enableStoreSelector) {
            url = removeStoreInventoryIds(url);
        }

        window.history.replaceState({}, "", url);

        selectedCounter();
        functionchangePrice();
        $('.refinements-container').on('scroll', function (event) {
            event.stopPropagation();
        });
        var navigationEntries = performance.getEntriesByType('navigation');
        if (navigationEntries.length > 0) {
            var navigationEntry = navigationEntries[0];
            // Check the type of navigation
            switch (navigationEntry.type) {
                case 'back_forward':
                    var storedScrollPosition = sessionStorage.getItem('scrollPosition');
                    if (storedScrollPosition) {
                        window.scrollTo(0, parseInt(storedScrollPosition));
                    }
                    break;
                default:
                    sessionStorage.removeItem('scrollPosition');
                    break;
            }
        }
    },

    sort: function () {
        // Handle sort order menu selection
        let searchBackUrl = JSON.parse($('#searchBackUrl').val());
        if (searchBackUrl) { window.addEventListener('popstate', function (e) { location.reload(); }); }
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            var sortUrl = new URL(this.value);
            if (searchBackUrl) { updateUrlToFrendly(sortUrl); }
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $('.container').on('click', '.show-more button', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var showMoreUrl = $(this).data('url');
            $.spinner().start();
            var updatedUrl = createSearchShowUrlWithParams(showMoreUrl);
            updateUrlToFrendly(updatedUrl);
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: 'GET',
                success: function (response) {
                    var searchShowUrlWithParams = $('#searchShowUrlWithParams').val();
                    // updateUrlToFrendly(searchShowUrlWithParams);
                    $('.grid-footer').replaceWith(response);
                    updateSortOptions(response);
                    $('body').trigger('search:showMoreFinished', e);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // addEventListener in the back button ('popstate') reload the page to load the catalog with the filters located at the URL //
        let searchBackUrl = JSON.parse($('#searchBackUrl').val());
        if (searchBackUrl) { window.addEventListener('popstate', function (e) { location.reload(); }); }

        // Handle refinement value selection and reset click
        $(".container").on(
            "click",
            ".refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .refinement-pill .fa-close, .btn-close-icon",
            function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const target = $(this);
            const url = target.data("href");

            const enableStoreSelector = $('input[name="enableStoreSelector"]').val() === "true";
            const isStoreChange = target.hasClass("store-filter") || target.hasClass("store-refinement");
            const isStoreRemoval = target.hasClass("removeFilter") && target.data("refinement-id") === "storeInventoryIds";
            const isResetWithStore = target.hasClass("reset");
            const checkCartStatusUrl = $("#cart-status-url").val();

            // If this action changes or removes the selected store,
            // verify whether the basket contains products before applying the filter.
            if (enableStoreSelector && (isStoreChange || isStoreRemoval || isResetWithStore)) {
                $.ajax({
                    url: checkCartStatusUrl,
                    type: "GET",
                    success: function (response) {

                        // Keep the current store when the basket contains products.
                        if (response.hasItems && response.hasSelectedStore) {

                            window.pendingStoreFilter = {
                                target: target,
                                event: e,
                                url: url,
                                source: isStoreChange
                                    ? "store-change"
                                    : "store-remove"
                            };

                            storeSelectorModal.showMixedOriginModal(response.message, response.title, true, null, response.titleBtn);

                            return;
                        }

                        executeFilter(target, e, url, response.hasItems);
                    },
                    error: function () {
                        // Continue with the normal flow if the validation request fails.
                        executeFilter(target, e, url, false);
                    }
                });

                return;
            }

            executeFilter(target, e, url, false);
            }
        );
    },
    getPage: function () {
        // get Page Paginate
        let searchBackUrl = JSON.parse($('#searchBackUrl').val());
        if (searchBackUrl) { window.addEventListener('popstate', function (e) { location.reload(); }); }
        $('.container').on('click', '.pagination-page', function (e) {
            e.stopPropagation();
            var pageUrl = $(this).data('url');
            if (searchBackUrl) { updateUrlToFrendly(pageUrl); }
            e.preventDefault();
            $.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: pageUrl,
                data: { selectedUrl: pageUrl },
                method: 'GET',
                success: function (response) {
                    $('.row.product-grid').html(response);
                    updateSortOptions(response);
                    $('html, body').animate({ scrollTop: 0 }, 100);
                    $('body').trigger('search:showMoreFinished', e);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    updateSortUrl: function () {
        const searchParamName = 'srule';
        $('#product-search-results').on('search:sort', (e, url) => {
            const localUrl = new URL(url, window.location.href);
            const searchParamValue = localUrl.searchParams.get(searchParamName) || '';
            $('#product-search-results').attr('data-' + searchParamName, searchParamValue);
        });
    }
};
searchExports.resize = null;
module.exports = searchExports;